import { LocalDictionaryFactory } from '../../api/api.module';
import { LoggerService } from '../../common/common.module';
import { DataTypeGroupDetailsDirectiveController } from './data-type-group-details.controller';
import { $SCOPE_SERVICE_NAME, $Q_SERVICE_NAME, $TIMEOUT_SERVICE_NAME, $COMPILE_SERVICE_NAME } from '../../../services/system';
import { USER_SESSION_SERVICE_NAME, UserSessionService } from '../../../services/user-session';
import { DataTypeGroupService, DATA_TYPE_GROUP_SERVICE_NAME } from '../../../services/data-type-group';

//#region Asset Imports

import './data-type-group-details.scss'
import * as TEMPLATE from './data-type-group-details.tpl.html'

//#endregion

// Setup

export class DataTypeGroupDetailsDirective implements ng.IDirective {

    restrict = 'E'

    scope = {
        id: '='
    }

    controller = [
        $SCOPE_SERVICE_NAME,
        $TIMEOUT_SERVICE_NAME,
        $Q_SERVICE_NAME,
        $COMPILE_SERVICE_NAME,
        'logger',
        'localDictionary',
        USER_SESSION_SERVICE_NAME,
        DATA_TYPE_GROUP_SERVICE_NAME,
        (
            $scope: any,
            $timeout: ng.ITimeoutService,
            $q: ng.IQService,
            $compile: ng.ICompileService,
            logger: LoggerService,
            localDictionary: LocalDictionaryFactory,
            userSession: UserSessionService,
            dataTypeGroupService: DataTypeGroupService,
        ) => new DataTypeGroupDetailsDirectiveController(
            $scope,
            $timeout,
            $q,
            $compile,
            logger,
            localDictionary,
            userSession,
            dataTypeGroupService,
            DataTypeGroupService.REFERENCE_TYPE,
            DataTypeGroupService.SIMAX_MODULE_NAME
        )]

    template = TEMPLATE
}

// Setup End